const RESET_STATE = 'coverArtModalScreen/RESET_STATE';
const SET_IS_SHOWING = 'coverArtModalScreen/SET_IS_SHOWING';

const SET_SCENE = 'coverArtModalScreen/SET_SCENE';

const SET_SEARCH_TEXT = 'coverArtModalScreen/SET_SEARCH_TEXT';

const SET_COVER_ART_IMAGE_URL = 'coverArtModalScreen/SET_COVER_ART_IMAGE_URL';

const SET_IMAGE_CHOICES = 'coverArtModalScreen/SET_IMAGE_CHOICES';
const ADD_IMAGE_CHOICES = 'coverArtModalScreen/ADD_IMAGE_CHOICES';

const SET_ZOOM_LEVEL = 'coverArtModalScreen/SET_ZOOM_LEVEL';
const SET_CROP_X_AXIS = 'coverArtModalScreen/SET_CROP_X_AXIS';
const SET_CROP_Y_AXIS = 'coverArtModalScreen/SET_CROP_Y_AXIS';

const SET_IS_HIDING_NAVIGATE_BACK_BUTTON_ON_CHOOSE_SCENE =
  'coverArtModalScreen/SET_IS_HIDING_NAVIGATE_BACK_BUTTON_ON_CHOOSE_SCENE';

const FETCH_IMAGE_CHOICES_START =
  'coverArtModalScreen/FETCH_IMAGE_CHOICES_START';
const FETCH_IMAGE_CHOICES_SUCCEEDED =
  'coverArtModalScreen/FETCH_IMAGE_CHOICES_SUCCEEDED';
const FETCH_IMAGE_CHOICES_FAILURE =
  'coverArtModalScreen/FETCH_IMAGE_CHOICES_FAILURE';

const FETCH_CROPPED_IMAGE_START =
  'coverArtModalScreen/FETCH_CROPPED_IMAGE_START';
const FETCH_CROPPED_IMAGE_SUCCEEDED =
  'coverArtModalScreen/FETCH_CROPPED_IMAGE_SUCCEEDED';
const FETCH_CROPPED_IMAGE_FAILURE =
  'coverArtModalScreen/FETCH_CROPPED_IMAGE_FAILURE';

const SET_FONT = 'coverArtModalScreen/SET_FONT';

const SET_CROPPED_IMAGE_PIXELS = 'coverArtModalScreen/SET_CROPPED_IMAGE_PIXELS';

const SET_JUSTIFICATION = 'coverArtModalScreen/SET_JUSTIFICATION';
const SET_ALIGNMENT = 'coverArtModalScreen/SET_ALIGNMENT';
const SET_TEXT_COLOR = 'coverArtModalScreen/SET_TEXT_COLOR';

const FETCH_TEXT_OVERLAY_IMAGES_START =
  'coverArtModalScreen/FETCH_TEXT_OVERLAY_IMAGES_START';
const FETCH_TEXT_OVERLAY_IMAGES_SUCCEEDED =
  'coverArtModalScreen/FETCH_TEXT_OVERLAY_IMAGES_SUCCEEDED';
const FETCH_TEXT_OVERLAY_IMAGES_FAILURE =
  'coverArtModalScreen/FETCH_TEXT_OVERLAY_IMAGES_FAILURE';

const FETCH_FINAL_COVER_ART_IMAGE_START =
  'coverArtModalScreen/FETCH_FINAL_COVER_ART_IMAGE_START';
const FETCH_FINAL_COVER_ART_IMAGE_SUCCEEDED =
  'coverArtModalScreen/FETCH_FINAL_COVER_ART_IMAGE_SUCCEEDED';
const FETCH_FINAL_COVER_ART_IMAGE_FAILURE =
  'coverArtModalScreen/FETCH_FINAL_COVER_ART_IMAGE_FAILURE';

const SET_TEXT_OVERLAY_IMAGES = 'coverArtModalScreen/SET_TEXT_OVERLAY_IMAGES';

const SET_IS_TEXT_SHOWING = 'coverArtModalScreen/SET_IS_TEXT_SHOWING';
const SET_IS_TEXT_COLOR_LOADING =
  'coverArtModalScreen/SET_IS_TEXT_COLOR_LOADING';

const SET_IS_HIDING_IMAGE_SEARCH =
  'coverArtModalScreen/SET_IS_HIDING_IMAGE_SEARCH';

const SET_IS_LOADING_IMAGE_TO_CROP =
  'coverArtModalScreen/SET_IS_LOADING_IMAGE_TO_CROP';

const SET_COVER_ART = 'coverArtModalScreen/SET_COVER_ART';
const SET_IS_FETCHING = 'coverArtModalScreen/IS_FETCHING';
const SET_IS_TEXT_IMAGE_LOADING =
  'coverArtModalScreen/SET_IS_TEXT_IMAGE_LOADING';

const SET_IS_COLOR_PICKER_SHOWING =
  'coverArtModalScreen/SET_IS_COLOR_PICKER_SHOWING';
const SET_FINAL_SCENE_BUTTON_TEXT =
  'coverArtModalScreen/SET_FINAL_SCENE_BUTTON_TEXT';

export default {
  RESET_STATE,
  SET_IS_HIDING_NAVIGATE_BACK_BUTTON_ON_CHOOSE_SCENE,
  SET_IS_SHOWING,
  SET_SCENE,
  SET_COVER_ART,
  SET_SEARCH_TEXT,
  SET_COVER_ART_IMAGE_URL,
  SET_IS_COLOR_PICKER_SHOWING,
  SET_IS_LOADING_IMAGE_TO_CROP,
  SET_IS_HIDING_IMAGE_SEARCH,
  ADD_IMAGE_CHOICES,
  SET_FONT,
  SET_ZOOM_LEVEL,
  SET_CROP_X_AXIS,
  SET_IS_TEXT_COLOR_LOADING,
  SET_CROP_Y_AXIS,
  SET_IS_TEXT_IMAGE_LOADING,
  SET_CROPPED_IMAGE_PIXELS,
  SET_IMAGE_CHOICES,
  FETCH_IMAGE_CHOICES_START,
  FETCH_IMAGE_CHOICES_SUCCEEDED,
  FETCH_IMAGE_CHOICES_FAILURE,
  FETCH_CROPPED_IMAGE_START,
  FETCH_CROPPED_IMAGE_SUCCEEDED,
  FETCH_CROPPED_IMAGE_FAILURE,
  SET_JUSTIFICATION,
  SET_ALIGNMENT,
  SET_TEXT_COLOR,
  FETCH_TEXT_OVERLAY_IMAGES_START,
  FETCH_TEXT_OVERLAY_IMAGES_SUCCEEDED,
  FETCH_TEXT_OVERLAY_IMAGES_FAILURE,
  SET_TEXT_OVERLAY_IMAGES,
  FETCH_FINAL_COVER_ART_IMAGE_START,
  FETCH_FINAL_COVER_ART_IMAGE_SUCCEEDED,
  FETCH_FINAL_COVER_ART_IMAGE_FAILURE,
  SET_IS_TEXT_SHOWING,
  SET_IS_FETCHING,
  SET_FINAL_SCENE_BUTTON_TEXT,
};
